export const PURPLE_LIGHT_BUTTON_COLORS = [
    {
        variable: '--btn-gradient-left-bg',
        value: '#347a66',
    },
    {
        variable: '--btn-gradient-center-bg',
        value: '#6f329b',
    },
    {
        variable: '--btn-gradient-right-bg',
        value: '#328c8a',
    },
];
export const PURPLE_LIGHT_LAYOUT_COLORS = [
    {
        variable: '--layout-content-bg',
        value: '#ffffff',
    },
    {
        variable: '--layout-page-bg',
        value: '#efefef',
    },
];
export const PURPLE_LIGHT_COLORS = [
    {
        variable: '--primary',
        value: '#765a8a',
        tooltip: 'usage in snack, input, links, buttons',
    },
    {
        variable: '--primary-light',
        value: '#8e6c9c',
    },
    {
        variable: '--primary-lighter',
        value: '#e0d8e5',
    },
    {
        variable: '--primary-dark',
        value: '#5a3c71',
    },
    {
        variable: '--blue-light',
        value: '#e5e0e6',
    },
    {
        variable: '--blue-lighter',
        value: '#e7e2e7',
    },
    {
        variable: '--success',
        value: '#3aa06b',
        tooltip: 'usage in snack, buttons, badge',
    },
    {
        variable: '--success-light',
        value: '#54b57a',
    },
    {
        variable: '--success-lighter',
        value: '#96cbb1',
    },
    {
        variable: '--success-dark',
        value: '#1f8349',
    },
    {
        variable: '--light-grey',
        value: '#e1dce5',
    },
    {
        variable: '--accent-white',
        value: '#aeb0b3',
    },
    {
        variable: '--grey',
        value: '#776e7e',
    },
    {
        variable: '--grey-dark',
        value: '#424f6c',
    },
    {
        variable: '--grey-light',
        value: '#8095c7',
    },
    {
        variable: '--black',
        value: '#363636',
    },
    {
        variable: '--danger',
        value: '#c52b1a',
        tooltip: 'usage in inputs, buttons, badge, snack',
    },
    {
        variable: '--danger-light',
        value: '#dc4a3a',
    },
    {
        variable: '--danger-lighter',
        value: '#dd8e8b',
    },
    {
        variable: '--danger-dark',
        value: '#b8354a',
    },
    {
        variable: '--warning',
        value: '#ebb921',
        tooltip: 'usage in buttons, badge, snack',
    },
    {
        variable: '--warning-light',
        value: '#eac43e',
    },
    {
        variable: '--warning-lighter',
        value: '#f4d388',
    },
    {
        variable: '--warning-dark',
        value: '#d37016',
    },
    {
        variable: '--accent',
        value: '#94adbd',
    },
    {
        variable: '--accent-light',
        value: '#bacccc',
    },
    {
        variable: '--accent-lighter',
        value: '#c1e2fb',
    },
    {
        variable: '--accent-dark',
        value: '#2978b5',
    },
    {
        variable: '--info',
        value: '#7870aa',
        tooltip: 'usage in buttons, badge, snack',
    },
    {
        variable: '--info-light',
        value: '#8f88bb',
    },
    {
        variable: '--info-lighter',
        value: '#b7b4cc',
    },
    {
        variable: '--info-dark',
        value: '#5e5882',
    },
    {
        variable: '--purple',
        value: '#7630dd',
    },
    {
        variable: '--white',
        value: '#ffffff',
        tooltip: 'usage in buttons/badge/snack... color text',
    },
    {
        variable: '--white-darker',
        value: '#e9e9e9',
    },
    {
        variable: '--light-hover',
        value: '#f4f1f5',
    },
    {
        variable: '--disabled-color',
        value: '#ebe7ee',
    },
    {
        variable: '--landing-bg',
        value: '#fcfdff',
    },
    {
        variable: '--loading-bg',
        value: '#f4f4f4',
    },
    {
        variable: '--sign-in-color-bg',
        value: '#eeeeee',
    },
    {
        variable: '--btn-link-hover-bg',
        value: '#dfd4e7',
    },
    {
        variable: '--btn-link-disabled-color',
        value: 'rgba(0,0,0,.26)',
    },
];
export const PURPLE_LIGHT_ALL_COLORS = [
    ...PURPLE_LIGHT_COLORS,
    ...PURPLE_LIGHT_BUTTON_COLORS,
    ...PURPLE_LIGHT_LAYOUT_COLORS,
];
export const PURPLE_LIGHT_COLOR_SCHEME = {
    otherColors: PURPLE_LIGHT_COLORS,
    buttonColors: PURPLE_LIGHT_BUTTON_COLORS,
    layoutColors: PURPLE_LIGHT_LAYOUT_COLORS,
};
